import {
  HubModule,
  HubModuleCTA,
  TitleSizeType,
} from '../../../../../../types';
import { HubModuleTypes } from '../../../../../../constants';
import { HubSponsorsDiscoveryBlock } from '../../../../../../store/features/discovery';
import { SponsorCategory } from './index';

export enum SponsorsModuleStyles {
  SCROLLING_LOGOS = 'SCROLLING_LOGOS',
  LOGOS = 'LOGOS',
  LOGOS_AND_TEXT = 'LOGOS_AND_TEXT',
}

export enum SponsorsModuleTitleTypes {
  NONE = 'NONE',
  CUSTOM = 'CUSTOM',
}

export enum SponsorsModuleRotateTypes {
  SINGLE = 'SINGLE',
  SMOOTH = 'SMOOTH',
  PAGE = 'PAGE',
}

export enum SponsorsModuleLayoutTypes {
  FULLSCREEN = 'FULLSCREEN',
}

export enum SponsorsModuleOrderTypes {
  DEFAULT = 'DEFAULT',
  ALPHABETICAL = 'ALPHABETICAL',
}

export enum SponsorsModuleTitleAlignmentTypes {
  CENTRE = 'CENTRE',
  LEFT = 'LEFT',
  RIGHT = 'RIGHT',
}

export interface SponsorsModuleType extends HubModule {
  '@type': HubModuleTypes.SponsorCategory;
  link: HubModuleCTA;
  rotateType: SponsorsModuleRotateTypes;
  style: SponsorsModuleStyles;
  title: string;
  titleSize: TitleSizeType;
  titleType: SponsorsModuleTitleTypes;
  layoutType: SponsorsModuleLayoutTypes;
  customTitle: string;
  sponsorsCategories: SponsorCategory[];
  sponsorsFromDiscovery: HubSponsorsDiscoveryBlock[];
  sponsorsOrder: SponsorsModuleOrderTypes;
  titleAlignment: SponsorsModuleTitleAlignmentTypes;
}
